import { axiosInstance } from "../helpers/AxiosConfiguration"




export const getVisitById = async (visitId) => {
    try {
        const response = await axiosInstance.get(`/api/v1/visits/${visitId}`);

        return response.data;
    } catch (error) {
        // If not found, technically not an error. Catch this and just clear the visit associated
        if (error.response && error.response.status && error.response.status === 404) {
            return null;
        }
        throw new Error(error)
    }
}

export async function createVisit(patientDetails, visitDetails) {
    try {
        // Format datetime objects for incident_occurred_at and efrt_activated_at
        const response = await axiosInstance.post('/api/v1/visits', {
            "patient_info": patientDetails,
            "details": {
                "incident_occurred_at": visitDetails["date"],
                "efrt_activated_at": visitDetails["ems_activation_time"],
                "ambulance_number": visitDetails["ambulance_number"],
                "transport": visitDetails["transport"],
            }
        })
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error(error);
    }
}


export async function putVisit({visitId, title=null, patientInfo=null, details=null, callInfo=null, treatmentInfo=null, vitalsInfo=null}) {
    try {
        const requestBody = {}
        if (title) {
            requestBody['title'] = title
        }

        if (patientInfo) {
            requestBody['patient_info'] = patientInfo
        }

        if (details) {
            requestBody['details'] = {
                "incident_occurred_at": details["date"],
                "efrt_activated_at": details["efrt_activation_time"],
                "ambulance_number": details["ambulance_number"],
                "transport": details["transport"],
            }
        }

        if (callInfo) {
            requestBody['call_info'] = {
                "user_edit": {
                    "value": callInfo
                },
            }
        }

        if (treatmentInfo) {
            requestBody['treatment_info'] = {
                "user_edit": {
                    "value": treatmentInfo
                },
            }
        }

        if (vitalsInfo) {
            requestBody['vitals_info'] = {
                "user_edit": {
                    "value": vitalsInfo
                },
            }
        }

        const response = await axiosInstance.put(`/api/v1/visits/${visitId}`, requestBody);

        return response.data
    } catch(error) {
        console.log(error);
        throw new Error(error);
    }
}